import { apiClient } from './client'
import type {
  AuthResponse,
  RefreshResponse,
  RegisterRequest,
  LoginRequest,
  LogoutRequest,
  RefreshRequest,
  User,
  UpdateProfileRequest,
} from '@/types'

export const authApi = {
  register: (data: RegisterRequest) => apiClient.post<AuthResponse>('/auth/register', data),

  login: (data: LoginRequest) => apiClient.post<AuthResponse>('/auth/login', data),

  logout: (data: LogoutRequest) => apiClient.post<{ message: string }>('/auth/logout', data),

  refresh: (data: RefreshRequest) => apiClient.post<RefreshResponse>('/auth/refresh', data),

  getProfile: () => apiClient.get<User>('/users/profile'),

  updateProfile: (data: UpdateProfileRequest) => apiClient.put<User>('/users/profile', data),

  deleteAccount: () => apiClient.delete<void>('/users/profile/delete'),
}
